import { MasterDataState, intitialState } from '../state/masterdata.state';
import {
    MasterDataActions,
    GET_MD_SUPPLIER_ADDRESS_CONTACT_TYPES_SUCCESS,
    GET_COUNTRY_LIST_SUCCESS,
    GET_LANGUAGE_LIST_SUCCESS,
    GET_CONTACT_ROLE_LIST_SUCCESS,
    GET_PART_LIST_SUCCESS,
    GET_TOOL_CATEGORIES_SUCCESS,
    GET_TOOL_SUB_CATEGORIES_SUCCESS,
    GET_CURRENCY_SUCCESS,
    GET_DOCUMENTTYPE_SUCCESS,
    GET_REGION_LIST_SUCCESS,
    GET_AGENCY_TYPES_SUCCESS,
    GET_DIVERSITY_TYPES_SUCCESS,
    GetFormTemplateSuccess,
    GET_FORM_TEMPLATES_SUCCESS,
    GET_CONTEXT_VERBIAGE_SUCCESS,
    GET_TAX_1099_BOXES_SUCCESS
} from '../actions/masterdata.action';
import { ToolSubcategory } from 'app/profile/models/generic.model';

export function MasterDataReducer(state: MasterDataState = intitialState, action: MasterDataActions): MasterDataState {
    switch (action.type) {

        case GET_AGENCY_TYPES_SUCCESS: {
            return {
                ...state,
                AgencyTypes: action.payload
            };
        }
        case GET_DIVERSITY_TYPES_SUCCESS: {
            return {
                ...state,
                DiversityTypes: action.payload
            };
        }

        case GET_MD_SUPPLIER_ADDRESS_CONTACT_TYPES_SUCCESS: {
            return {
                ...state,
                SupplierContactTypes: action.payload
            };
        }

        case GET_COUNTRY_LIST_SUCCESS: {
            return {
                ...state,
                countries: action.payload
            };
        }

        case GET_LANGUAGE_LIST_SUCCESS: {
            return {
                ...state,
                languages: action.payload
            };
        }

        case GET_CONTEXT_VERBIAGE_SUCCESS: {
          return {
              ...state,
              contextVerbiage: action.payload
          };
      }

        case GET_REGION_LIST_SUCCESS: {
            return {
                ...state,
                regions: action.payload
            };
        }

        case GET_CONTACT_ROLE_LIST_SUCCESS: {
            return {
                ...state,
                roles: action.payload
            };
        }

        case GET_PART_LIST_SUCCESS: {
            return {
                ...state,
                parts: action.payload
            };
        }

        case GET_TOOL_CATEGORIES_SUCCESS: {
            return {
                ...state,
                toolCategories: action.payload
            };
        }

        case GET_CURRENCY_SUCCESS: {
            return {
                ...state,
                currencies: action.payload
            };
        }

        case GET_DOCUMENTTYPE_SUCCESS: {
            return {
                ...state,
                documentTypes: action.payload
            };
        }

        case GET_TOOL_SUB_CATEGORIES_SUCCESS: {
            let subCategories: { [supplierCode: string]: ToolSubcategory[] } = null;

            if (state.toolSubCategories == null) {
                subCategories = {};
            }
            else {
                subCategories = state.toolSubCategories;
            }
            subCategories[action.supplierCode] = action.payload;
            return {
                ...state,
                toolSubCategories: subCategories
            };

        }

        case GET_FORM_TEMPLATES_SUCCESS: {
            return {
                ...state,
                FormTemplate: action.payload
            }
        }

        case GET_TAX_1099_BOXES_SUCCESS: {
            return {
                ...state,
                Tax1099Boxes: action.payload
            };
        }

        default: return state;
    }
}
